import { FC, useEffect, useState } from 'react';

import cx from 'classnames';
import styles from './FallingChips.module.scss';
import { ChipBingoIcon } from '@assets/icons';

const chipsPosition = [
  { x: 93, y: -33 },
  { x: 3, y: -40 },
  { x: 98, y: -64 },
  { x: 20, y: -75 },
  { x: 2, y: -103 },
  { x: 80, y: -106 },
  { x: 25, y: -133 },
  { x: 97, y: -118 },
];

interface FallingChipsProps {
  show?: boolean;
}

export const FallingChips: FC<FallingChipsProps> = ({ show = false }) => {
  const [falling, setFalling] = useState(false);

  useEffect(() => {
    if (falling || !show) return;
    setFalling(true);
    setTimeout(() => {
      setFalling(false);
    }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <div>
      {chipsPosition.map((pos, index) => (
        <div
          key={index}
          className={cx(styles.fcChip, { [styles.fcChipfalling]: falling })}
          style={{ left: `${pos.x}%`, top: `${pos.y}%` }}
        >
          <ChipBingoIcon
            width={18}
            height={18}
            style={{ display: !falling ? 'block' : 'block' }}
          />
        </div>
      ))}
    </div>
  );
};
